import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchToolBlacklist } from "./api";
import type { ToolBlacklistItem } from "./api";

// Запреты пары (org, role). key включает roleName (свой кэш на каждую
// роль). Запрос отключён без выбранной роли — список появляется только
// после того, как человек выбрал роль в Select.
export function useToolBlacklist(
  roleName: string | null,
): UseQueryResult<readonly ToolBlacklistItem[], Error> {
  return useOrgScopedQuery<readonly ToolBlacklistItem[]>({
    key: ["toolBlacklist", roleName],
    // queryFn бежит только при enabled (roleName !== null) — non-null assert
    // безопасен, ветка `?? ""` иначе мёртвая (не покрывается тестом).
    queryFn: () => fetchToolBlacklist(roleName!),
    enabled: roleName !== null,
    retry: false,
  });
}
